import Gravity from '@parent-theme/assets/js/global-functions';

const boxesWithTextAndImageSlider = () => {
    document
        .querySelectorAll('.gg-boxes-text-image')
        /* eslint-disable */
        .forEach((module) => {
            const swipers = module.querySelector('.gg-boxes-text-image__container');
            const swiperWrapper = module.querySelector('.gg-boxes-text-image__wrapper');

            const swiperSlides = module.querySelectorAll('.gg-box-text-image');

            if (!swipers || !swiperWrapper) {
                return;
            }
            let init = false;
            let carousel = null;

            const handleCarouselBasedOnWindowWidth = () => {
                const mobileBreakpoint = 640;
                if (window.innerWidth < mobileBreakpoint) {
                    if (!init) {
                        init = !init;

                        swipers.classList.add('swiper-container');
                        swiperWrapper.classList.add('swiper-wrapper');
                        swiperSlides.forEach((slide) => {
                            slide.classList.add('swiper-slide');
                        });

                        carousel = new window.Swiper(swipers, {
                            loop: false,
                            watchOverflow: true,
                            watchSlidesProgress: true,
                            slidesPerView: 1,
                            allowTouchMove: true,
                            autoplay: false,
                            delay: 5000,
                            disableOnInteraction: false,
                            spaceBetween: 24,
                            navigation: {
                                nextEl: '.swiper-button-next',
                                prevEl: '.swiper-button-prev',
                                disabledClass: 'button-disabled',
                            },
                        });

                        carousel.init();
                    }
                } else if (init) {
                    init = !init;
                    carousel.destroy();

                    swipers.classList.remove('swiper-container');
                    swiperWrapper.classList.remove('swiper-wrapper');
                    swiperSlides.forEach((slide) => {
                        slide.classList.remove('swiper-slide');
                    });
                }
            };

            const debounceDelay = 50;
            handleCarouselBasedOnWindowWidth();
            window.addEventListener('resize', Gravity.debounce(handleCarouselBasedOnWindowWidth, debounceDelay));
        });
};

Gravity.ready(boxesWithTextAndImageSlider);
